import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpService } from '../utilities/services/http.service';
import { fromEvent, map, debounceTime } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AgencyRoleType } from '../utilities/enums/agencyrole.enum';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-search-user',
  templateUrl: './search-user.component.html',
  styleUrls: ['./search-user.component.scss'],
})
export class SearchUserComponent implements OnInit, AfterViewInit {
  showLoader: boolean = true;
  @ViewChild('inputSearch', { static: true }) inputSearch!: ElementRef;
  userList: any[] = [];
  filteredUserList: any[] = [];
  searchValue;

  @Output() startChat = new EventEmitter();
  @Output() gotoConversations = new EventEmitter();
  @Output() openNewMessage = new EventEmitter();
  @Output() closeUser = new EventEmitter();

  constructor(
    private router: Router,
    private _snackBar: MatSnackBar,
    private httpService: HttpService,
    public translate: TranslateService,
    public appComponent: AppComponent
  ) {
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang() || 'en';
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
  }

  ngOnInit(): void { }
  ngAfterViewInit(): void {
    this.debounce(this.inputSearch.nativeElement, 'keyup').subscribe((val) => {
      // console.log(`Debounced Input: ${val}`);
      if (val.length == 0)
        this.clearSearch();
      if (val.length >= 2)
        this.getUsers(val);
      // this.filterUserList(val)
    });

    this.getUsers();
  }

  debounce(element: any, event: any, time = 500) {
    const eventObserver = fromEvent(
      this.inputSearch.nativeElement,
      'keyup'
    ).pipe(map((i: any) => i.currentTarget.value));
    return eventObserver.pipe(debounceTime(500));
  }

  getUsers(search?: string) {
    this.showLoader = true;
    this.httpService.getUsers(search, 100).subscribe({
      next: (res: any) => {
        this.showLoader = false;
        this.userList = res.data;
        if (this.searchValue !== "") {
          this.userList.forEach((user, index) => {
            if (user.user.tags) {
              if (user.user.tags.indexOf(this.searchValue) > -1) {
                let foundTagList = user.user.tags.split(';');
                foundTagList.map(tag => {
                  if (tag.indexOf(this.searchValue) > -1) {
                    if (!this.userList[index].user.foundTags)
                      this.userList[index].user.foundTags = tag;
                    else
                      this.userList[index].user.foundTags += ", " + tag;
                  }
                })
              }
            }
          })
        }
        this.filteredUserList = this.userList;
      },
      error: (error) => {
        console.log(error.status);
        if (error.status === 401) {
          this.appComponent.renewToken()
          // localStorage.clear();
          // this.router.navigate(['/login']);
        }
      },
      complete: () => { },
    });
  }

  checkYou(email: string) {
    return localStorage.getItem('userEmail') === email;
  }

  gotoChat(data: any) {
    if (this.checkRole(data.Role)) {
      // this.startChat.emit(data.user);
      this.startChat.emit(data);
    } else {
      this.translate.get('SEARCH_USER.PERMISSION').subscribe((res: string) => {
        this.openSnackBar(res, '');
      });
    }
  }

  gotoConversation() {
    this.gotoConversations.emit(true);
  }

  gotoNewMessage() {
    this.openNewMessage.emit(true);
  }

  close() {
    this.closeUser.emit(true);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  checkRole(Role: string) {
    // remove the below line to work code as per role
    const loginUserRole = localStorage.getItem('Role');
    if (
      loginUserRole === AgencyRoleType.ADMIN ||
      loginUserRole === AgencyRoleType.OWNER ||
      loginUserRole === AgencyRoleType.AGENCYADMIN ||
      loginUserRole === AgencyRoleType.AGENCYNURSE ||
      loginUserRole === AgencyRoleType.SUPPORT ||
      loginUserRole === AgencyRoleType.SPECIALTYSUPPORT ||
      loginUserRole === AgencyRoleType.SEMBRANETADMIN ||
      loginUserRole === AgencyRoleType.SEMBRANETNURSE||
      loginUserRole === AgencyRoleType.SEMBRANETOFFICE
    ) {
      // as per rule the above roles can chat with everyone
      return true;
    } else if (loginUserRole === AgencyRoleType.USER || loginUserRole === AgencyRoleType.CAREGIVER) {
      if (
        Role === AgencyRoleType.ADMIN ||
        Role === AgencyRoleType.AGENCYADMIN ||
        Role === AgencyRoleType.AGENCYNURSE ||
        Role === AgencyRoleType.OWNER ||
        Role === AgencyRoleType.SUPPORT ||
        Role === AgencyRoleType.SPECIALTYSUPPORT
      ) {
        return true;
      } else if (Role === AgencyRoleType.USER || Role === AgencyRoleType.CAREGIVER) {
        // login user role are basic or care giver as per rule both are not chat each other or broadcast
        return false;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  clearSearch() {
    this.searchValue = "";
    this.getUsers();
  }

  getIVRID(IVRID: string) {
    return IVRID.replace(/\D/g, "");
  }

  getRoleName(role) {
    if (role.toLowerCase() === "support")
      return "SembraCare Success"
    else if (role.toLowerCase() === "specialtysupport")
      return "SembraCare Specialty Support"
    else if (role.toLowerCase() === "sembranetadmin")
      return "SembraNet Management"
    else if (role.toLowerCase() === "sembranetnurse")
      return "SembraNet Nurse"
    else if (role.toLowerCase() === "sembranetoffice")
      return "SembraNet Office"
    else if (role.toLowerCase() === "agencyadmin")
      return "Agency Admin"
    else if (role.toLowerCase() === "agencynurse")
      return "Agency Nurse"
    else
      return role.substring(0, 1) + role.substring(1, role.Length).toLowerCase()
  }

  filterUserList(val) {
    let newFilteredList: any[] = [];
    this.userList.map(user => {
      try {
        let userProfile = user.user;
        let userRole = user.Role;
        let userName = userProfile.Username;
        let userFullName = userProfile.LastName ? userProfile.LastName + ", " + userProfile.FirstName : "";
        let IVRID = userProfile.IVRID ? userProfile.IVRID : "";
        let agencyCode = userProfile.agencycode ? userProfile.agencycode : "";
        let branch = userProfile.Branch ? userProfile.Branch : "";

        if (userRole.indexOf(val) > -1 || userName.indexOf(val) > -1 || userFullName.indexOf(val) > -1 || IVRID.indexOf(val) > -1 || agencyCode.indexOf(val) > -1 || branch.indexOf(val) > -1)
          newFilteredList.push(user)
      } catch { }
    })

    this.filteredUserList = newFilteredList;
  }
}
